(() => {
  const STORAGE_KEY = 'theme-recently-viewed-handles';
  const MAX_STORE = 40;

  function readHandles() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.filter((h) => typeof h === 'string' && h.length) : [];
    } catch {
      return [];
    }
  }

  function writeHandles(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, MAX_STORE)));
    } catch {
      /* ignore quota / private mode */
    }
  }

  function pruneHandle(handle) {
    const list = readHandles().filter((h) => h !== handle);
    writeHandles(list);
  }

  // 明示的な例外マッピング。snippets/fulfillment-hidden-redirect-target.liquid と同期を保つこと。
  const HIDDEN_HANDLE_EXCEPTIONS = new Set(['150027', '150028']);

  function isFulfillmentOnlyHandle(handle) {
    return HIDDEN_HANDLE_EXCEPTIONS.has(handle) || /^7\d+$/.test(handle);
  }

  function recordVisit(handle) {
    if (!handle) return;
    let list = readHandles().filter((h) => h !== handle);
    list.unshift(handle);
    writeHandles(list);
  }

  class RecentlyViewedProducts extends HTMLElement {
    async connectedCallback() {
      const isDesignMode = typeof Shopify !== 'undefined' && Shopify.designMode;
      const cardSectionId = this.dataset.cardSection || 'recently-viewed-product-card';
      const limit = Math.max(1, parseInt(this.dataset.limit || '8', 10));
      const currentHandle = (this.dataset.currentHandle || '').trim();
      const horizontal = this.dataset.horizontal !== 'false';

      const contentRoot = this.querySelector('[data-recently-viewed-root]');
      const track = this.querySelector('[data-recently-viewed-track]');
      if (!track || !contentRoot) return;

      let handles = readHandles().filter((h) => h !== currentHandle && !isFulfillmentOnlyHandle(h));
      handles = [...new Set(handles)].slice(0, limit);

      if (!handles.length) {
        if (currentHandle) recordVisit(currentHandle);
        if (!isDesignMode) this.closest('section')?.remove();
        return;
      }

      const fragment = document.createDocumentFragment();
      const liClass = horizontal ? 'related-products__slide grid__item' : 'grid__item';

      let rootUrl = this.dataset.rootUrl || '/';
      if (!rootUrl.endsWith('/')) rootUrl = `${rootUrl}/`;

      for (const handle of handles) {
        try {
          const url = `${rootUrl}products/${encodeURIComponent(handle)}?section_id=${encodeURIComponent(cardSectionId)}`;
          const res = await fetch(url);
          if (!res.ok) {
            pruneHandle(handle);
            continue;
          }
          const text = await res.text();
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const source = doc.querySelector('.js-recently-viewed-card-root');
          const inner = source?.innerHTML?.trim();
          if (!inner) {
            pruneHandle(handle);
            continue;
          }
          const li = document.createElement('li');
          li.className = liClass;
          li.innerHTML = inner;
          fragment.appendChild(li);
        } catch {
          pruneHandle(handle);
        }
      }

      if (!fragment.children.length) {
        if (currentHandle) recordVisit(currentHandle);
        if (!isDesignMode) this.closest('section')?.remove();
        return;
      }

      track.appendChild(fragment);
      contentRoot.removeAttribute('hidden');

      if (typeof window.bindHorizontalCarouselNav === 'function') {
        window.bindHorizontalCarouselNav(this);
      } else if (typeof window.bindRelatedProductsViewportWheelScroll === 'function') {
        window.bindRelatedProductsViewportWheelScroll(this);
      }

      if (currentHandle) recordVisit(currentHandle);
    }
  }

  if (!customElements.get('recently-viewed-products')) {
    customElements.define('recently-viewed-products', RecentlyViewedProducts);
  }
})();
